import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
const faqs = [{
  q: '¿Cómo recibo el Combo?',
  a: 'Por email, inmediatamente después del pago. Acceso 24/7.'
}, {
  q: '¿Sirve si soy principiante?',
  a: 'Sí. El Tomo 1 empieza desde cero. Cada tomo indica su nivel.'
}, {
  q: '¿Funciona con sierra circular y taladro?',
  a: 'Sí. No necesitás maquinaria industrial.'
}, {
  q: '¿Los 6 bonos están en las dos ofertas?',
  a: 'Sí. El Sistema Micro-Fábrica es el único adicional de la Opción 2.'
}, {
  q: '¿Y si no consigo un herraje?',
  a: 'El Bono 2 tiene tabla completa de sustitutos. Siempre tenés alternativa.'
}];
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-12 md:py-16 bg-white" data-id="element-53">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-54">
        <h2 className="text-2xl md:text-3xl font-black text-wood-dark mb-8 text-center" data-id="element-55">
          PREGUNTAS FRECUENTES
        </h2>
        <div className="space-y-3" data-id="element-56">
          {faqs.map((faq, index) => <div key={index} className="border border-wood-light/20 rounded-xl overflow-hidden bg-cream-dark" data-id="element-57">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-5 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-wood-light/5 transition-colors" data-id="element-58">
                <span className="font-bold text-wood-dark pr-6" data-id="element-59">{faq.q}</span>
                <ChevronDown className={`w-5 h-5 text-amber flex-shrink-0 transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-60" />
              </button>
              <AnimatePresence data-id="element-61">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-62">
                    <div className="px-5 pb-4 pt-1 text-charcoal/80 text-sm border-t border-wood-light/10" data-id="element-63">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}